import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SentryHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((response: HttpErrorResponse) => {
        if (location.protocol === 'https:' && response.error?.error !== 'UNAUTHORIZED_USER') {
          const { method } = req;
          const { status, url } = response;
          const message = `${status} ${method} ${url}`;

          Sentry.captureEvent({
            logger: 'SentryHttpInterceptor',
            fingerprint: [message],
            message,
            extra: {
              response: JSON.stringify(response),
            },
            tags: {
              method,
              status: `${status}`,
              url,
            },
          });
        }
        return throwError(response);
      })
    );
  }
}
